import "./styles.scss";

const ParticipantRow = ({ participant, highlightRole }) => (
  <div className="participantsCard__row">
    <img src={participant.avatarUrl} alt={participant.displayName} className="participantsCard__avatar" />
    <div>
      <div className="participantsCard__name">{participant.displayName}</div>
      <div className={`participantsCard__role${highlightRole ? " participantsCard__role--highlight" : ""}`}>
        {participant.role}
      </div>
    </div>
  </div>
);

const ParticipantsCard = ({ participantsCard }) => {
  if (!participantsCard) return null;
  const { teacher, students = [] } = participantsCard;

  return (
    <div className="participantsCard">
      <span className="participantsCard__decor" />
      <h3 className="participantsCard__title">👥 Active Session Roles</h3>
      <div className="participantsCard__list">
        {teacher && <ParticipantRow participant={teacher} />}
        {students.map((student) => (
          <ParticipantRow key={student.userId} participant={student} highlightRole />
        ))}
      </div>
    </div>
  );
};

export default ParticipantsCard;
